import Utils from '@/providers/Utils'

export default {

    // -------- tool options ----------

    toolName: 'progressMonitor',
    label: 'Progress Monitor',
    logo: 'Progress-Monitor-logo-32.png',

    getDefaultData() {
        return {
            docTitle: 'Untitled',
            currentStep: 1,
            fontFace: 'sans',
            fontSize: 'small',

            studentName: null,
            schoolName: null,
            adultName: null,
            collectorName: null,
            todayDate: Utils.noonToday(), // see app.module.js
            interventionTarget: null,

            collectionMethod: null,
            formatMin: null,
            formatMax: null,
            formatTitle: null,

            startDate: null,
            endDate: null,

            averageRating: null,
            dataPoints: null,

            goalOption: null,
            goalDataPoints: null,
        }
    },

    steps: [
        {id: 1, title: 'Enter background information'},
        {id: 2, title: 'Select a method for data collection'},
        {id: 3, title: 'Enter intervention dates'},
        {id: 4, title: 'Enter baseline data (Optional)'},
        {id: 5, title: 'Set a goal for success'},
        // { id: 6, title: 'Download the student data-collection report' }
    ],

    // define which download methods are supported - see ToolContainerPreviewToolbar::inject
    provide: function () {
        return {
            downloadDocFile: null,
            downloadPdfFile: null,
            exportToGoogleForms: null,
        }
    },

}
